<!--
    描述：指标分析---添加对比弹窗页面
    时间：2020-06-04
    Created by ws
-->
<template>
	<div class="add-compare-home bd-table">
		<div class="add-compare-header">
			<el-button type="warning"
					   size="mini"
					   class="ml10"
					   @click="doReset">重置</el-button>
			<el-button size="mini"
					   class="ml10"
					   @click="doSearch">确定筛选</el-button>
		</div>
		<!-- 表单 -->
		<div class="add-compare-form">
			<el-form label-width="80px"
					 size="small"
					 :model="searchForm">
				<el-row>
					<el-col :span="6">
						<el-form-item label="地区">
							<el-cascader :options="areaList"
										 :props="props"
										 collapse-tags
										 clearable
										 v-model="searchForm.curArea"></el-cascader>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="项目来源">
							<el-select v-model="searchForm.projectResource"
									   multiple
									   placeholder="请选择">
								<el-option v-for="(item, index) in gcly"
										   :key="'来源' + index"
										   :label="item.sname"
										   :value="item.value">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="开工日期">
							<el-date-picker v-model="searchForm.startDate"
											type="date"
											placeholder="选择日期"
											format="yyyy 年 MM 月 dd 日"
											value-format="yyyy-MM-dd"></el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="招标方式">
							<el-select v-model="searchForm.bidMethod"
									   multiple
									   collapse-tags
									   placeholder="请选择">
								<el-option v-for="(item, index) in zbfs"
										   :key="'招标方式' + index"
										   :label="item.sname"
										   :value="item.value">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>

				<el-row>
					<el-col :span="6">
						<el-form-item label="建设单位">
							<el-input v-model="searchForm.companyBuild"
									  placeholder="请输入"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="合同金额">
							<el-row>
								<el-col :span="10">
									<el-input v-model="searchForm.moneyContractPrice1"
											  placeholder="请输入"
											  type="number"></el-input>
								</el-col>
								<el-col :span="4">至</el-col>
								<el-col :span="10">
									<el-input v-model="searchForm.moneyContractPrice2"
											  placeholder="请输入"
											  type="number"></el-input>
								</el-col>
							</el-row>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="竣工日期">
							<el-date-picker v-model="searchForm.endDate"
											type="date"
											placeholder="选择日期"
											format="yyyy 年 MM 月 dd 日"
											value-format="yyyy-MM-dd"></el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="施工单位">
							<el-input v-model="searchForm.companyConstruction"
									  placeholder="请输入"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
		</div>
		<!-- 表格 -->
		<el-table ref="xTable"
				  :height="380"
				  :data="compareData"
				  highlight-current-row
				  border
				  v-loading="loading"
				  stripe>
			<el-table-column type="index"
							 label="序号"
							 align="center"
							 width="70"></el-table-column>
			<el-table-column prop="projectName"
							 label="工程名称"
							 v-if="curLevel === 0"
							 align="center"
							 min-width="150px"
							 sortable
							 show-overflow-tooltip></el-table-column>
			<el-table-column prop="danXiangName"
							 label="单项工程名称"
							 v-if="curLevel === 1"
							 align="center"
							 min-width="150px"
							 sortable
							 show-overflow-tooltip></el-table-column>
			<el-table-column prop="projectPatten"
							 label="工程类型"
							 align="center"
							 min-width="120px"
							 sortable
							 show-overflow-tooltip></el-table-column>
			<el-table-column prop="projectOrigin"
							 label="项目来源"
							 align="center"
							 min-width="110px"
							 sortable
							 show-overflow-tooltip></el-table-column>
			<el-table-column prop="beginDate"
							 label="开工年份"
							 width="110px"
							 align="center"
							 sortable
							 show-overflow-tooltip></el-table-column>
			<el-table-column prop="endDate"
							 label="竣工年份"
							 width="110px"
							 align="center"
							 sortable
							 show-overflow-tooltip></el-table-column>
			<el-table-column prop="areaName"
							 label="地区"
							 width="120px"
							 align="center"
							 sortable
							 show-overflow-tooltip></el-table-column>
			<el-table-column prop="companyBuild"
							 label="建设单位"
							 align="center"
							 width="120px"
							 sortable
							 show-overflow-tooltip></el-table-column>
			<el-table-column prop="companyConstruction"
							 label="施工单位"
							 align="center"
							 width="120px"
							 show-overflow-tooltip></el-table-column>
			<el-table-column prop="bidMethod"
							 label="招标方式"
							 align="center"
							 width="110px"
							 show-overflow-tooltip></el-table-column>
			<el-table-column prop="moneyContractPrice"
							 label="合同金额"
							 align="center"
							 show-overflow-tooltip></el-table-column>

			<el-table-column width="90px"
							 align="center">
				<template slot="header"
						  slot-scope="scope">
					<el-checkbox size="mini"
								 v-model="checkAll.estimateMoney"
								 @change="handleCheckAll($event,'estimateMoney')">概算价</el-checkbox>
				</template>
				<template slot-scope="scope">
					<el-checkbox :true-label="1"
								 :false-label="0"
								 v-model="scope.row.sixCalculationMap.estimateMoney"
								 :disabled="scope.row.sixCalculationMap.estimateMoney==2"></el-checkbox>
				</template>
			</el-table-column>
			<el-table-column width="90px"
							 align="center">
				<template slot="header"
						  slot-scope="scope">
					<el-checkbox size="mini"
								 v-model="checkAll.controlMoney"
								 @change="handleCheckAll($event,'controlMoney')">控制价</el-checkbox>
				</template>
				<template slot-scope="scope">
					<el-checkbox :true-label="1"
								 :false-label="0"
								 v-model="scope.row.sixCalculationMap.controlMoney"
								 :disabled="scope.row.sixCalculationMap.controlMoney==2"></el-checkbox>
				</template>
			</el-table-column>
			<el-table-column width="90px"
							 align="center">
				<template slot="header"
						  slot-scope="scope">
					<el-checkbox size="mini"
								 v-model="checkAll.biddingMoney"
								 @change="handleCheckAll($event,'biddingMoney')">中标价</el-checkbox>
				</template>
				<template slot-scope="scope">
					<el-checkbox :true-label="1"
								 :false-label="0"
								 v-model="scope.row.sixCalculationMap.biddingMoney"
								 :disabled="scope.row.sixCalculationMap.biddingMoney==2"></el-checkbox>
				</template>
			</el-table-column>
			<el-table-column width="90px"
							 align="center">
				<template slot="header"
						  slot-scope="scope">
					<el-checkbox size="mini"
								 v-model="checkAll.reportMoney"
								 @change="handleCheckAll($event,'reportMoney')">送审价</el-checkbox>
				</template>
				<template slot-scope="scope">
					<el-checkbox :true-label="1"
								 :false-label="0"
								 v-model="scope.row.sixCalculationMap.reportMoney"
								 :disabled="scope.row.sixCalculationMap.reportMoney==2"></el-checkbox>
				</template>
			</el-table-column>
			<el-table-column width="90px"
							 align="center">
				<template slot="header"
						  slot-scope="scope">
					<el-checkbox size="mini"
								 v-model="checkAll.beforeMoney"
								 @change="handleCheckAll($event,'beforeMoney')">初审价</el-checkbox>
				</template>
				<template slot-scope="scope">
					<el-checkbox :true-label="1"
								 :false-label="0"
								 v-model="scope.row.sixCalculationMap.beforeMoney"
								 :disabled="scope.row.sixCalculationMap.beforeMoney==2"></el-checkbox>
				</template>
			</el-table-column>
			<el-table-column width="90px"
							 align="center">
				<template slot="header"
						  slot-scope="scope">
					<el-checkbox size="mini"
								 v-model="checkAll.afterMoney"
								 @change="handleCheckAll($event,'afterMoney')">审定价</el-checkbox>
				</template>
				<template slot-scope="scope">
					<el-checkbox :true-label="1"
								 :false-label="0"
								 v-model="scope.row.sixCalculationMap.afterMoney"
								 :disabled="scope.row.sixCalculationMap.afterMoney==2"></el-checkbox>
				</template>
			</el-table-column>
		</el-table>
	</div>
</template>

<script>
import { selectProjectList } from '@/api/modules/dataProject'
import { mapState } from 'vuex'
export default {
	name: 'add_compare_home',
	props: {
		// 当前层级 （0 是项目， 1是单项）
		curLevel: {
			type: Number,
			default: 0
		},
		// 当前左侧ID
		curRowId: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			loading: false,
			//筛选后数据
			compareData: [],
			checkAll: {
				estimateMoney: false,
				controlMoney: false,
				reportMoney: false,
				beforeMoney: false,
				afterMoney: false,
				biddingMoney: false
			},
			searchForm: {
				curArea: [], //地区
				projectResource: [], //来源
				startDate: '', //开始时间
				bidMethod: [], //招标方式
				companyBuild: '', //建设单位
				moneyContractPrice1: '', //合同金额起始范围
				moneyContractPrice2: '', //合同金额结束范围
				endDate: '', //竣工日期
				companyConstruction: '' //施工单位
			},
			props: { multiple: true }
		}
	},
	methods: {
		//进行全选
		handleCheckAll(val, type) {
			this.compareData.map(x => {
				if (x.sixCalculationMap[type] !== 2) {
					x.sixCalculationMap[type] = val ? 1 : 0
				}
			})
		},

		// 搜索操作
		doSearch() {
			this.loading = true
			let params = Object.assign({}, this.searchForm)
			params.areaList = []
			params.curArea.forEach(x => {
				let a = x.join(',')
				params.areaList.push(a)
			})
			setTimeout(() => {
				selectProjectList({
					id: this.curRowId,
					levelType: this.curLevel,
					projectOriginList: this.searchForm.projectResource,
					bidMethodList: this.searchForm.bidMethod,
					companyBuild: this.searchForm.companyBuild,
					companyConstruction: this.searchForm.companyConstruction,
					contractAmountBegin: this.searchForm.moneyContractPrice1,
					contractAmountEnd: this.searchForm.moneyContractPrice2,
					beginDate: this.searchForm.startDate,
					endDate: this.searchForm.endDate,
					curArea: params.areaList
				})
					.then(res => {
						this.loading = false
						this.compareData = res.data.param
					})
					.catch(err => {
						this.loading = false
					})
			}, 100)
		},

		// 筛选框重置事件
		doReset() {
			this.searchForm.curArea = []
			this.searchForm.projectResource = []
			this.searchForm.startDate = ''
			this.searchForm.bidMethod = []
			this.searchForm.companyBuild = ''
			this.searchForm.moneyContractPrice1 = ''
			this.searchForm.moneyContractPrice2 = ''
			this.searchForm.endDate = ''
			this.searchForm.companyConstruction = ''

			Object.keys(this.checkAll).map(x => {
				this.checkAll[x] = false
			})

			this.doSearch()
		},

		// 点击保存
		doSave() {
			let list = JSON.parse(JSON.stringify(this.compareData))
			let resArr = []
			list.forEach(x => {
				let status = false
				for (let k in x.sixCalculationMap) {
					if (x.sixCalculationMap[k] === 1) {
						status = true
					}
				}
				status ? resArr.push(x) : ''
			})
			// console.log(resArr)

			if (resArr.length > 0) {
				this.$emit('onSuccess', resArr)
			} else {
				this.$message.info('当前未选择对比的数据！')
			}
		}
	},
	created() {
		// 初始获取数据
		this.doSearch()
		// this.curLevel === 0 ? this.doSearch() : ''
	},
	computed: {
		...mapState('projectInfo', {
			curProjectId: state => state.curProjectId
		}),
		...mapState('dict', {
			gcly: state => state.gcly, // 工程来源数组
			gclx: state => state.gclx, // 工程类型数组
			areaList: state => state.areaList, // 地区数组
			zbfs: state => state.zbfs // 招标方式数组
		})
	}
}
</script>

<style lang="less" scoped>
.add-compare-home {
    height: 100%;
    
    .add-compare-header {
        height: 38px;
        text-align: left;
    }
}
//@import url("./home.less");
</style>
